(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    const MOBILE_BREAKPOINT = 640;

    function mergeTypeAndLocation() {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      document.querySelectorAll('.careers-apply__row').forEach(row => {
        const type = row.querySelector('.careers-apply__cell--type');
        const location = row.querySelector('.careers-apply__cell--location');

        if (!type || !location) return;

        // İlk hâlleri sakla
        if (!type.dataset.originalText) {
          type.dataset.originalText = type.textContent.trim();
        }

        if (!location.dataset.originalText) {
          location.dataset.originalText = location.textContent.trim();
        }

        if (isMobile) {
          // Birleştir
          type.textContent =
            `${type.dataset.originalText}, ${location.dataset.originalText}`;

          // Location'ı görselden kaldır
          location.style.display = 'none';
        } else {
          // Desktop'a geri dön
          type.textContent = type.dataset.originalText;
          location.textContent = location.dataset.originalText;
          location.style.display = '';
        }
      });
    }

    window.addEventListener('load', mergeTypeAndLocation);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(mergeTypeAndLocation, 150);
    });

    var rows = document.querySelectorAll("[data-careers-row]");
    if (!rows.length) {
      return;
    }

    var lottiePlayer = window.lottie || window.bodymovin;
    if (!lottiePlayer) {
      return;
    }

    rows.forEach(function (row) {
      var icon = row.querySelector("[data-lottie-apply]");
      if (!icon || icon.dataset.lottieReady === "true") {
        return;
      }
      icon.dataset.lottieReady = "true";
      icon.textContent = "";

      var animation = lottiePlayer.loadAnimation({
        container: icon,
        renderer: "svg",
        loop: true,
        autoplay: false,
        path: "/assets/lottie/arrow_anim_lottie.json",
        rendererSettings: {
          preserveAspectRatio: "xMidYMid meet"
        }
      });

      if (animation && animation.goToAndStop) {
        animation.goToAndStop(0, true);
      }

      var play = function () {
        if (!animation) {
          return;
        }
        animation.stop();
        animation.play();
      };

      var stop = function () {
        if (!animation) {
          return;
        }
        animation.stop();
        if (animation.goToAndStop) {
          animation.goToAndStop(0, true);
        }
      };

      row.addEventListener("mouseenter", play);
      row.addEventListener("mouseleave", stop);
      row.addEventListener("focusin", play);
      row.addEventListener("focusout", stop);
    });
  });
})();
